// extracted by mini-css-extract-plugin
export default {"showScrollToTopButton":"scroll-to-top-module__showScrollToTopButton__kMQb7","scrollToTop":"scroll-to-top-module__scrollToTop__IGCvY"};